import { getValidDate, getRoundIntegerNum, getRoundIntegerNumEmpty, toFirstUpperCase } from '@gp/utils/common';
import { ECHART_COLOR } from '@gp/constants/const';
import { BASE_BAR_SERIES_OPTION, BASE_ECHART_OPTION, LEGEND_GRID_SPACING } from '@gp/constants/echarts';

const getEChartOpt = (data: orgHeadcountsDataTypes) => {
  const xAxisLabelList: string[] = []; // x轴刻度名列表
  const targetMetrics = data?.metrics || [], targetData = data?.dataList || [];
  const _series = [];
  if (Array.isArray(targetMetrics) && targetMetrics?.length) {
    for (let i = 0, len = targetMetrics?.length; i < len; i++) {
      const t: string = targetMetrics?.[i], isLastItem = i === (len - 1);
      const dataList: { value: string | null, data: { [key: string]: string } | null, [keyName: string]: any }[] = [], // 每个指标每个刻度的数据
        totalDataList: { value: string | null, data: { [key: string]: string } | null }[] = [];
      for (let j = 0; j < targetData?.length; j++) {
        const k: { [key: string]: string } = targetData?.[j],
              isForecast = k?.valueType === 'forecast';
        i === 0 && xAxisLabelList?.push(getValidDate(k?.['date'], 'YYYY-MM'));
        dataList.push({
          value: k?.[t] || null,
          data: k || null,
          itemStyle: {
            opacity: isForecast ? 0.4 : 1,
            decal: isForecast
              ? {
                  symbol: 'rect',
                  color: 'rgba(255, 255, 255, 1)',
                  dashArrayX: [4, 16],
                  dashArrayY: [1, 0],
                  rotation: 45,
                }
              : {
                  symbol: 'none',
                },
          },
        });
        isLastItem && totalDataList.push({
          value: '0',
          data: k || null,
        });
      }
      _series.push({
        ...BASE_BAR_SERIES_OPTION,
        name: t,
        type: 'bar',
        stack: 'metric',
        barMaxWidth: 64,
        barGap: 0,
        data: dataList,
        /* emphasis: {
          focus: 'series',
        }, */
      });
      // 柱子顶部显示total
      if (isLastItem) {
        _series.push({
          name: '', // 没有名称，这样图例就不会显示出来
          type: 'bar',
          stack: 'metric',
          barMaxWidth: 64,
          barGap: 0,
          data: totalDataList,
          label: {
            ...BASE_BAR_SERIES_OPTION.label,
            show: true,
            formatter: (params: any) => {
              const { data } = params;
              const month = (data?.data?.date || '')?.substring(5, 7);
              const isEvenMonth = month && (Number(month) % 2 === 0);
              return isEvenMonth ? getRoundIntegerNumEmpty(data?.data?.total) : '';
            },
          },
        });
      }
    }
  }

  return {
    ...BASE_ECHART_OPTION,
    color: ECHART_COLOR,
    title: {
      show: false,
    },
    grid: {
      ...BASE_ECHART_OPTION.grid,
      top: BASE_ECHART_OPTION?.grid?.top + BASE_BAR_SERIES_OPTION.label?.distance + BASE_BAR_SERIES_OPTION?.label?.fontSize,
      bottom: LEGEND_GRID_SPACING,
    },
    legend: {
      ...BASE_ECHART_OPTION.legend,
      show: false,
      height: 0,
      selected: null,
    },
    xAxis: {
      ...BASE_ECHART_OPTION.xAxis,
      show: true,
      type: 'category',
      data: xAxisLabelList,
      axisLabel: { // 刻度文案设置
        ...BASE_ECHART_OPTION.xAxis?.axisLabel,
        margin: 16,
      },
    },
    yAxis: [
      {
        ...BASE_ECHART_OPTION.yAxis?.[0],
        type: 'value',
        splitLine: { // 分割线设置
          ...BASE_ECHART_OPTION.yAxis?.[0]?.splitLine,
        },
        axisLabel: { // 刻度文案设置
          ...BASE_ECHART_OPTION.yAxis?.[0]?.axisLabel,
          formatter: (v: any) => getRoundIntegerNum(v),
        },
        // minInterval: 5,
        // maxInterval: 5,
        // interval: 5,
      },
    ],
    series: _series,
  };
}

// tooltip浮窗内容
const tootipFormatter = (params: any) => {
  let name = '',
    subName = '',
    // 第一列名称
    firItemListStr = `
        <div class="header-flex  margin-10">
          <div>Total</div>
        </div>
      `,
    // 第二列数据
    secItemListStr = `<div class="body-num  margin-10">${getRoundIntegerNum(params?.[0]?.data?.data?.total)}</div>`;

  const paramsLen: number = params?.length || 0;
  if (Array.isArray(params) && paramsLen) {
    for (let i = 0; i < paramsLen; i++) {
      const t = params?.[i];
      if (!t?.seriesName) continue; // 没有名称的是total
      if (!name) name = getValidDate(t?.data?.data?.date, 'YYYY-MM');
      if (!subName) subName = toFirstUpperCase(t?.data?.data?.valueType);
      firItemListStr += `
        <div class="dbg-flex  margin-10">
          <span class='general-circular-dot' style="background-color: ${t?.color};"></span>
          <div>${t?.seriesName}</div>
        </div>
      `;
      secItemListStr += `<div class='body-num  margin-10' style="text-align: right;">${getRoundIntegerNum(t?.value)}</div>`;
    }
  }

  const htmlStr = `
    <section class='echart-tooltip-style-content'>
      <div class="header-flex">
        <div style="margin-right: 20px">
          <div class="margin-10">${name || '-'}</div>
          <div class="header-title">
            ${firItemListStr || '-'}
          </div>
        </div>
        <div style="">
          <div class="margin-10">${subName || '-'}</div>
          <div>
            ${secItemListStr || '-'}
          </div>
        </div>
      </div>
    <section>
  `;
  return htmlStr;
}

export {
  getEChartOpt,
  tootipFormatter,
}
